module.exports = __webpack_public_path__ + "img/2f_l_tomatsu.afb85a99.png";